module.exports = __webpack_public_path__ + "20c6e27ff9f778328c45c21c461c760e.svg";